import { render, staticRenderFns } from "./Reviewers.vue?vue&type=template&id=5ce87c08&scoped=true&"
import script from "./Reviewers.vue?vue&type=script&lang=js&"
export * from "./Reviewers.vue?vue&type=script&lang=js&"
import style0 from "./Reviewers.vue?vue&type=style&index=0&id=5ce87c08&prod&lang=css&"
import style1 from "./Reviewers.vue?vue&type=style&index=1&id=5ce87c08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce87c08",
  null
  
)

export default component.exports